// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Uilz","toggle":"styles_toggle__dTDRq","preview":"styles_preview__otWrF"};